window['ThemeComponent_Quantity'] = () => {
  return {
    quantity: 6,
    dispatchInputChange() {
      this.$refs.quantityInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    },
    decreaseQuantity() {
      if (this.quantity >= 12) {
        this.quantity = this.quantity - 6;
      }
      this.dispatchInputChange();
      return liveRegion(this.quantity);
    },
    increaseQuantity() {
        this.quantity = this.quantity + 6;
      this.dispatchInputChange();
      return liveRegion(this.quantity);
    }
  };
};
